
import { Component, Prop, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../../framework/state';
import { ApplicationResource } from '../../../../../../../common/application/enumeration/ApplicationResource';
import { VehicleContractComment } from '../../../../../../../common/application/model/VehicleContractComment';
import { QueryParameters } from '../../../../../../../common/application/model/QueryParameters';
import { dateToUiDateTimeString } from '../../../../../../../common/framework/util/convert';
import { getResource } from '../../../../../../framework/client/resource';
import { User } from '../../../../../../../common/framework/model/User';
import { FrameworkResource } from '../../../../../../../common/framework/enumeration/FrameworkResource';

@Component({})
export default class ViewVehicleContractComment extends Vue {
    readonly resourceType = ApplicationResource.VEHICLE_CONTRACT_COMMENT;

    @Prop() readonly comment!: VehicleContractComment;

    shared = sharedState;
    local = {
        commentUser: {} as User,
        loading: false,
        parameters: {} as QueryParameters,
    };

    async mounted() {
        this.local.loading = true;
        await this.loadAsyncData();
        this.local.loading = false;
    }

    get commentTitle(): string {
        let title = '';

        if (this.comment.userId === this.shared.context.userId) {
            title += `${this.$t('label.you')}`;
        } else {
            if (!this.local.commentUser) {
                title += `${this.$t('label.unknownUser')}`;
            } else {
                title += `${this.local.commentUser.firstName} ${this.local.commentUser.lastName}`;
            }
        }

        title += ` @ ${dateToUiDateTimeString(new Date(this.comment.created))}`;

        return title;
    }

    get commentType(): 'default' | 'is-info' {
        if (this.comment.userId === this.shared.context.userId) {
            return 'is-info';
        } else {
            return 'default';
        }
    }

    private async loadAsyncData(): Promise<void> {
        this.local.commentUser = (await getResource<User>(FrameworkResource.USER, this.comment.userId))!!;
    }
}
